import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from "recharts";
import type { PortfolioAllocation } from "../../types/api";

const colors = [
  "#22d3ee",
  "#818cf8",
  "#f472b6",
  "#34d399",
  "#fbbf24",
  "#a855f7",
];

interface AllocationDonutProps {
  data: PortfolioAllocation[];
}

export const AllocationDonut = ({ data }: AllocationDonutProps) => {
  const chartData = data.map((allocation) => ({
    symbol: allocation.assetSymbol,
    name: allocation.assetName,
    percentage: allocation.percentage,
  }));

  return (
    <div className="h-64 w-full">
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie
            data={chartData}
            dataKey="percentage"
            nameKey="symbol"
            innerRadius="60%"
            outerRadius="90%"
            stroke="rgba(15,23,42,0.2)">
            {chartData.map((entry, index) => (
              <Cell
                key={entry.symbol}
                fill={colors[index % colors.length]}
                strokeWidth={2}
              />
            ))}
          </Pie>
          <Tooltip
            contentStyle={{
              background: "rgba(2,6,23,0.9)",
              borderRadius: "12px",
              border: "1px solid rgba(255,255,255,0.1)",
              color: "#fff",
            }}
            labelStyle={{ color: "#fff" }}
            itemStyle={{ color: "#fff" }}
            formatter={(value, name, props) => [
              `${value}% – ${props.payload.name}`,
              name,
            ]}
          />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};
